import axios from "axios";
import React, { useEffect, useRef, useState } from "react";

export default function DataJateng() {
  const sectionRef = useRef(null);

  const [isVisible, setIsVisible] = useState(false);
  const [summary, setSummary] = useState({
    students: 0,
    teachers: 0,
    schools: 0,
  });

  const [counts, setCounts] = useState({
    students: 0,
    teachers: 0,
    schools: 0,
  });

  const getSummary = async () => {
    try {
      const response = await axios.get(
        "https://madrasahjateng.geschool.net/_api/main/stats",
        {
          headers: {
            Accept: "application/json",
          },
        }
      );

      const data = response.data?.summary;

      setSummary({
        students: Number(data?.students || 0),
        teachers: Number(data?.teachers || 0),
        schools: Number(data?.schools || 0),
      });
    } catch (e) {
      console.log(
        "Gagal mengambil data summary:",
        e.response?.data || e.message
      );
    }
  };

  useEffect(() => {
    getSummary();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000;
    const startTime = performance.now();

    const startValues = {
      students: 0,
      teachers: 0,
      schools: 0,
    };

    const animateCounter = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 3);

      setCounts({
        students: Math.floor(startValues.students + summary.students * easeOut),
        teachers: Math.floor(startValues.teachers + summary.teachers * easeOut),
        schools: Math.floor(startValues.schools + summary.schools * easeOut),
      });

      if (progress < 1) {
        requestAnimationFrame(animateCounter);
      } else {
        setCounts(summary);
      }
    };

    requestAnimationFrame(animateCounter);
  }, [isVisible, summary]);

  const formatNumber = (value) => {
    return new Intl.NumberFormat("id-ID").format(Number(value || 0));
  };

  const data = [
    {
      value: counts.students,
      title: "Siswa Terdaftar",
      subtitle: "Aktif menggunakan platform",
    },
    {
      value: counts.teachers,
      title: "Guru",
      subtitle: "Telah Terlatih Digital",
    },
    {
      value: counts.schools,
      title: "Madrasah Terkoneksi",
      subtitle: "Digitalisasi Modern",
    },
  ];

  return (
    <>
      <style>{`
  .stats-section {
    width: 100%;
   
    background: #dff3e4;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 72px 60px;
    box-sizing: border-box;
  }

  .stats-container {
    width: 100%;
    max-width: 1860px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 30px;
  }

  .stats-card {
    position: relative;
    width: 100%;
    min-height: 286px;
    background: #ffffff;
    border-radius: 14px;
    overflow: hidden;
    text-align: center;
    padding: 34px 32px 38px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  .stats-card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 5px;
    width: 100%;
    background: #009b69;
  }

  .stats-card h2 {
    margin: 0 0 20px;
    color: #009b69;
    font-size: 96px;
    line-height: 1;
    font-weight: 700;
  }

  .stats-card h4 {
    margin: 0 0 16px;
    color: #00460f;
    font-size: 34px;
    line-height: 1.2;
    font-weight: 700;
  }

  .stats-card p {
    margin: 0;
    color: #c9c9c9;
    font-size: 25px;
    line-height: 1.35;
  }

  @media (max-width: 1024px) {
    .stats-section {
      min-height: auto;
      padding: 56px 24px;
    }

    .stats-container {
      gap: 18px;
    }

    .stats-card {
      min-height: 230px;
      padding: 28px 18px;
    }

    .stats-card h2 {
      font-size: 62px;
    }

    .stats-card h4 {
      font-size: 24px;
    }

    .stats-card p {
      font-size: 18px;
    }
  }

  @media (max-width: 767px) {
    .stats-section {
      padding: 40px 20px;
    }

    .stats-container {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .stats-card {
      min-height: 220px;
      border-radius: 12px;
    }

    .stats-card h2 {
      font-size: 64px;
    }

    .stats-card h4 {
      font-size: 26px;
    }

    .stats-card p {
      font-size: 18px;
    }
  }
`}</style>

      <section ref={sectionRef} className="stats-section">
        <div className="stats-container">
          {data.map((item) => (
            <div className="stats-card" key={item.title}>
              <h2>{formatNumber(item.value)}</h2>
              <h4>{item.title}</h4>
              <p>{item.subtitle}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
